import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * BackButton — smart back navigation.
 * Uses browser history if available, falls back to `fallback` route.
 * Drop just below <Navbar /> at the top of a nested page.
 */
export default function BackButton({ fallback = "/", label = "Back", className = "" }) {
  const navigate = useNavigate();
  const go = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };
  return (
    <button
      type="button"
      onClick={go}
      data-testid="back-btn"
      className={`inline-flex items-center gap-1.5 text-sm text-zinc-400 hover:text-white transition-colors group ${className}`}
    >
      <ArrowLeft className="h-4 w-4 group-hover:-translate-x-0.5 transition-transform" />
      {label}
    </button>
  );
}
